import { CommonModule } from '@angular/common';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';

import { DashboardRoutes } from '@app/dashboard/dashboard.routing';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { SharedModule } from '@app/shared';
import { CategoryComponent } from './category/category.component';
import { ProductsComponent } from './products/products.component';
import { WarehouseComponent } from './warehouse/warehouse.component';
import { ClientComponent } from './client/client.component';
import { OrderComponent } from './order/order.component';
import { OrderListComponent } from './order/order-list/order-list.component';
import { CreateOrderComponent } from './order/order/create-order.component';
import { CreateClientComponent } from './client/create-cliente/create-cliente.component';
import { CurrencyPipe } from '@angular/common';
import { OrderEditComponent } from './order/order-edit/order-edit.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ExpenseComponent } from './expense/expense.component';
import { ExpenseCreateComponent } from './expense/expense-create/expense-create.component';
import { ExpenseListComponent } from './expense/expense-list/expense-list.component';
import { UsuarioListComponent } from './usuarios/usuario-list/usuario-list.component';
import { UsuarioCreateComponent } from './usuarios/usuario-create/usuario-create.component';
import { CategoryListComponent } from './category/category-list/category-list.component';
import { CategoryCreateComponent } from './category/category-create/category-create.component';
import { DashboardComponent } from '@app/dashboard/dashboard';
import { ProductListComponent } from './products/product-list/product-list.component';
import { ProductCreateComponent } from './products/product-create/product-create.component';
import { WarehouseCreateComponent } from './warehouse/warehouse-create/warehouse-create.component';
import { WarehouseListComponent } from './warehouse/warehouse-list/warehouse-list.component';
import { UsuarioEditComponent } from './usuarios/usuario-edit/usuario-edit.component';
import { ClienteListComponent } from './client/cliente-list/cliente-list.component';
import { ReportesComponent } from './reportes/reportes.component';
import { ExistenciaComponent } from './reportes/existencia/existencia.component';
import { VentaComponent } from './reportes/venta/venta.component';
import { GastoComponent } from './reportes/gasto/gasto.component';
import { UnityComponent } from './unity/unity.component';
import { UnityListComponent } from './unity/unity-list/unity-list.component';
import { UnityCreateComponent } from './unity/unity-create/unity-create.component';
import { OrderDetailsComponent } from './order/order-details/order-details.component';
import { VentasComponent } from './ventas/ventas.component';
import { PagosComponent } from './ventas/pagos/pagos.component';
import { PreciosComponent } from './reportes/precios/precios.component';
import { PedidosComponent } from './reportes/pedidos/pedidos.component';
import { DeudasComponent } from './reportes/deudas/deudas.component';
import { DespachadosComponent } from './order/order-list/despachados/despachados.component';
import { ConcluidosComponent } from './order/order-list/concluidos/concluidos.component';
import { AnuladosComponent } from './order/order-list/anulados/anulados.component';
import { OrdenesComponent } from './order/order-list/ordenes/ordenes.component';
import { AlmacenComponent } from './reportes/almacen/almacen.component';
import { ReporteVentasComponent } from './reportes/reporte-ventas/reporte-ventas.component';
import { PedidosGlobalesComponent } from './order/order-list/pedidos-globales/pedidos-globales.component';
import { MonetizadoComponent } from './reportes/monetizado/monetizado.component';
import { SeguimientoComponent } from './reportes/seguimiento/seguimiento.component';
import { SumPipeModule } from '@app/shared/pipes/sum.pipe';
import { ProformasComponent } from './proformas/proformas.component';
import { CreateproformaComponent } from './proformas/createproforma/createproforma.component';
import { EditproformaComponent } from './proformas/editproforma/editproforma.component';
import { CobranzasComponent } from './reportes/cobranzas/cobranzas.component';
import { ListarVisitasComponent } from './client/listar-visitas/listar-visitas.component';
import { CrearVisitasComponent } from './client/crear-visitas/crear-visitas.component';
import { VisitasComponent } from './visitas/visitas.component';
import { CrearVisitaComponent } from './visitas/crear-visita/crear-visita.component';
import { PagoProveedorComponent } from './pago-proveedor/pago-proveedor.component';
import { CreatePagopComponent } from './pago-proveedor/create-pagop/create-pagop.component';

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    NgbModule,
    NgSelectModule,
    SharedModule,
    RouterModule.forChild(DashboardRoutes)
  ],
  declarations: [
    DashboardComponent,
    UsuariosComponent,
    CategoryComponent,
    ProductsComponent,
    WarehouseComponent,
    ClientComponent,
    OrderComponent,
    CreateOrderComponent,
    OrderListComponent,
    CreateClientComponent,
    OrderEditComponent,
    ExpenseComponent,
    ExpenseCreateComponent,
    ExpenseListComponent,
    UsuarioListComponent,
    UsuarioCreateComponent,
    CategoryListComponent,
    CategoryCreateComponent,
    ProductListComponent,
    ProductCreateComponent,
    WarehouseCreateComponent,
    WarehouseListComponent,
    UsuarioEditComponent,
    ClienteListComponent,
    ReportesComponent,
    ExistenciaComponent,
    VentaComponent,
    GastoComponent,
    UnityComponent,
    UnityListComponent,
    UnityCreateComponent,
    OrderDetailsComponent,
    VentasComponent,
    PagosComponent,
    PreciosComponent,
    PedidosComponent,
    DeudasComponent,
    DespachadosComponent,
    ConcluidosComponent,
    AnuladosComponent,
    OrdenesComponent,
    AlmacenComponent,
    ReporteVentasComponent,
    PedidosGlobalesComponent,
    MonetizadoComponent,
    SeguimientoComponent,
    ProformasComponent,
    CreateproformaComponent,
    EditproformaComponent,
    CobranzasComponent,
    ListarVisitasComponent,
    CrearVisitasComponent,
    VisitasComponent,
    CrearVisitaComponent,
    PagoProveedorComponent,
    CreatePagopComponent,
  ],
  entryComponents: [
    CreateClientComponent,
    UsuarioCreateComponent,
    CategoryCreateComponent,
    ProductCreateComponent,
    WarehouseCreateComponent,
    UsuarioEditComponent,
    UnityCreateComponent,
    CrearVisitaComponent,
    CreatePagopComponent
  ],
  providers: [CurrencyPipe, DatePipe, {provide: LOCALE_ID, useValue: 'es'}]
})
export class DashboardModule {

  
}
